import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Pageable, SpringPage } from '../../content.utils';

export interface ContentLandingPage {
  html: string;
  queryPath: string;
  published: boolean;
  seoTitle: string;
  seoDescription: string | null;
  lastModifiedDate: string;
}

@Injectable({
  providedIn: 'root',
})
export class LandingPageApiService {
  private readonly baseUrl = '/api/content/landing-pages';
  private readonly httpClient = inject(HttpClient);

  static toHttpParams(pageable: Pageable, searchQuery?: string): HttpParams {
    let request = new HttpParams().set('page', pageable.page).set('size', pageable.size);
    if (searchQuery && searchQuery.length > 2) {
      request = request.append('search', searchQuery);
    }
    return request;
  }

  getLandingPages(pageable: Pageable, searchQuery?: string): Observable<SpringPage<ContentLandingPage>> {
    return this.httpClient.get<SpringPage<ContentLandingPage>>(this.baseUrl, {
      params: LandingPageApiService.toHttpParams(pageable, searchQuery),
    });
  }

  getLandingPage(queryPath: string): Observable<ContentLandingPage> {
    queryPath = encodeURIComponent(queryPath);
    return this.httpClient.get<ContentLandingPage>(`${this.baseUrl}?queryPath=${queryPath}`);
  }

  createLandingPage(body: ContentLandingPage): Observable<ContentLandingPage> {
    return this.httpClient.post<ContentLandingPage>(`${this.baseUrl}`, body);
  }

  updateLandingPage(body: ContentLandingPage): Observable<ContentLandingPage> {
    return this.httpClient.put<ContentLandingPage>(`${this.baseUrl}`, body);
  }

  deleteLandingPage(queryPath: string) {
    queryPath = encodeURIComponent(queryPath);
    return this.httpClient.delete(`${this.baseUrl}?queryPath=${queryPath}`);
  }
}
